// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cPF5R","badges":"styles_badges__2f1dN"};